
// NATIVE 

// INSTALLED 
import { hideIconRequestErrors } from '../errors';
import { setDateValid } from '../../commons/utils';
import { checkingPreload, unCheckingPreload } from '../loading';
import { activeExpressCheckinService, createExpressCheckinService, 
         desactiveExpressCheckinService, getCodeExpressCheckinByPaginateService, 
         getExpressCheckinService, getOneExpressCheckinService, updateExpressCheckinService } from '../../services/expressChecking';
import { setRegistroExpressCheckinListRedux, storeRegistroExpressCheckinRedux } from './registroExpressCheckinSlice';
import { getRegistroExpressCheckinService } from '../../services/registroExpressCheckin';



// CUSTOM 




export const getRegistrosExpressCheckinStore = (): any => {

    return async( dispatch: any ) => {
       

        await dispatch( checkingPreload() );

        const result = await  getRegistroExpressCheckinService();

       
        if ( result.ok ) {
          await dispatch( setRegistroExpressCheckinListRedux(result.data) );
        }

        dispatch( unCheckingPreload() );

        return result;


    }

  
}




export const getCodeExpressCheckinByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
  
       

      const result = await  getCodeExpressCheckinByPaginateService(page);


      if ( result.ok ) {
        await dispatch( setRegistroExpressCheckinListRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}




export const storeCodeExpressCheckin = (codeExpressCheckin: any, percentage:any): any => {

    return async( dispatch: any ) => {


      
      
      const dataSave = {
        "code":          codeExpressCheckin.code,
        "adults":        codeExpressCheckin.adults,
        "minors":        codeExpressCheckin.minors,
        "arrivalDate":   setDateValid(codeExpressCheckin.arrival),
        "departureDate": setDateValid(codeExpressCheckin.departure),
        "isBussines":    Number(codeExpressCheckin.bussines)
      }

    

      const result = await  createExpressCheckinService(dataSave, percentage);

    
      if ( result.ok ) {
          await dispatch( setRegistroExpressCheckinListRedux(result.data) );
      }

      
      return result;
        
    }
}



// export const storeDetailAreas = (areaId: string): any => {
    

//   return async( dispatch: any ) => { 


//       await dispatch( checkingPreload() );
      

//       const result = await  getAreaDetailService(areaId);
    

//       if ( result.ok ) {
//            await dispatch( storeAreaRedux(result.data) );
//       }

//       dispatch( unCheckingPreload() );

//       return result;

//   }

    
// }



export const storeEditarExpressCheckin = (codeExpressCheckinId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      

      const result = await  getOneExpressCheckinService(codeExpressCheckinId);
    

      if ( result.ok ) {
          await dispatch( storeRegistroExpressCheckinRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}



export const storeEditExpressCheckin = (codeExpressCheckin: any): any => {
    

  return async( dispatch: any ) => { 
      

    const dataSave = {
      "expressCheckingId" : codeExpressCheckin.expressCheckingId,
      "code":          codeExpressCheckin.e_code,
      "adults":        codeExpressCheckin.e_adults,
      "minors":        codeExpressCheckin.e_minors,
      "arrivalDate":   setDateValid(codeExpressCheckin.e_arrival),
      "departureDate": setDateValid(codeExpressCheckin.e_departure),
      "isBussines":    Number(codeExpressCheckin.e_bussines)
    }



      const result = await  updateExpressCheckinService(dataSave);
    

      if ( result.ok ) {
        await dispatch( setRegistroExpressCheckinListRedux(result.data) );
      }


      return result;

  }

    
}





export const storeDesactiveCodeExpressCheckin = (codeExpressCheckinId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );

      const result = await  desactiveExpressCheckinService(codeExpressCheckinId);
      
      
      if ( result.ok ) {
          await dispatch( setRegistroExpressCheckinListRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}




export const storeActiveCodeExpressCheckin = (codeExpressCheckinId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  activeExpressCheckinService(codeExpressCheckinId);


      if ( result.ok ) {
          await dispatch( setRegistroExpressCheckinListRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}